module.exports = __webpack_public_path__ + "static/media/linksight-logo.2538706b.svg";